import PrefsService from "../services/PrefsService"

export default function migration1 () {
    let prefs = JSON.parse(PrefsService.get('baseStationDetailsDashboard', '{}'));

    for (let key in prefs) {
        if (prefs[key] instanceof Object && 'dashlets' in prefs[key]) {
            let dashlets = prefs[key]['dashlets'];
            for (let dashlet of dashlets) {
                if (dashlet.value === "uplinkAirTime") {
                    dashlet.name = 'tower.db.AirTime'
                    dashlet.value = 'AirTime'
                    dashlet.i = dashlet.i.replace('uplinkAirTime', 'AirTime')
                } else if (dashlet.value === "UplinkAirtimeByCustomer") {
                    dashlet.name = 'tower.db.AirTimeByCustomer'
                    dashlet.value = 'AirTimeByCustomer'
                    dashlet.i = dashlet.i.replace('UplinkAirtime', 'AirTime')
                } else if (dashlet.value === "downlinkAirTime") {
                    dashlet.name = 'tower.db.AirTime'
                    dashlet.value = 'AirTime'
                    dashlet.i = dashlet.i.replace('downlinkAirTime', 'AirTime')
                } else if (dashlet.value === "DownlinkAirtimeByCustomer") {
                    dashlet.name = 'tower.db.AirTimeByCustomer'
                    dashlet.value = 'AirTimeByCustomer'
                    dashlet.i = dashlet.i.replace('DownlinkAirtime', 'AirTime')
                }
            }
        }
    }
    PrefsService.put('baseStationDetailsDashboard', JSON.stringify(prefs))
}